export default __webpack_public_path__ + "static/media/420.28231a50.jpg";